// ObservacoesAgendamentoTooltip.jsx
import React from "react";
import { Info } from "lucide-react";
import { Tooltip } from "@mui/material";
import "./ObservacoesAgendamentoTooltip.scss";

function ObservacoesAgendamentoTooltip({ observacoes }) {
  // Se não houver observações, retorna apenas um traço
  if (!observacoes || observacoes.trim() === "") {
    return <span>-</span>;
  }

  return (
    <Tooltip
      title={
        <div className="observacoes-tooltip">
          <div className="observacoes-tooltip__content">{observacoes}</div>
        </div>
      }
      arrow
      placement="top"
    >
      <div className="observacoes-tooltip-trigger">
        <Info fontSize="small" />
      </div>
    </Tooltip>
  );
}

export default ObservacoesAgendamentoTooltip;
